// Copyright (c) 2019 Deere & Company

import './index.scss';
import React, { Component } from 'react';
import AuthenticatedPage from '../app/common/components/authenticated-page';
import ComponentFunctionCodeMaintenance from './components/component-function-code-maintenance';
import PropTypes from 'prop-types';

class ComponentFunctionCodeMaintainencePage extends Component {

    state= {
        navParameter: '',
    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.location.state === 'componentCode' ) {

            this.setState( {
                navParameter: nextProps.location.state,
            } );

        }

    }

    updateReload = () => {

        this.setState( {
            navParameter: '',
        } );

    }

    render () {

        return (
            <AuthenticatedPage className="admin-page">
                <ComponentFunctionCodeMaintenance
                    reload={this.state.navParameter}
                    updateReload={this.updateReload}
                />
            </AuthenticatedPage>
        );

    }

}

ComponentFunctionCodeMaintainencePage.displayName = 'ComponentFunctionCodeMaintainencePage';
ComponentFunctionCodeMaintainencePage.propTypes = {
    location: PropTypes.object.isRequired,
};
export default ComponentFunctionCodeMaintainencePage;
